<!--
   Copyright 2019 Amazon.com, Inc. or its affiliates. All Rights Reserved.
   SPDX-License-Identifier: MIT-0
-->

<div ngClass="main" fxLayout="column" fxFlex="1 1 auto" fxLayout.lt-md="column" fxLayoutAlign="center center"
  fxLayoutAlign.xs="start center">
  <router-outlet></router-outlet>
</div>